(function (app) {

    app.directive("figLogoSrc",
    [
        "transactionGroupApi", function (transactionGroupApi) {
            return {
                scope: {
                    transactionGroupId: "<figLogoSrc",
                    newSrc: "@?",
                    hasLogo: "=hasLogo"
                },
                link: function (scope, elem, attrs) {
                    scope.$watch("newSrc", updateSrc);
                    scope.$watch("transactionGroupId", updateSrc);
                    var lastObjUrl;

                    scope.$on("$destroy",
                        function () {
                            if (lastObjUrl)
                                URL.revokeObjectURL(lastObjUrl);
                        });

                    function updateSrc(transactionGroupId) {
                        if (!transactionGroupId) return;
                        
                        if (!!attrs.newSrc) {
                            elem[0].src = attrs.newSrc;
                            elem.addClass("picture-returned");
                            scope.hasLogo = true;
                            return;
                        }

                        transactionGroupApi.getLogo(transactionGroupId).then(function (response) {
                            var url = URL.createObjectURL(response);
                            elem[0].src = url;
                            elem.addClass("picture-returned");
                            scope.hasLogo = true;

                            if (lastObjUrl)
                                URL.revokeObjectURL(lastObjUrl);
                            lastObjUrl = url;

                        }, function () {

                        });
                    }

                }
            }
        }
    ]);

    app.directive("figDisclosureSrc", ["disclosureApi",
        function (disclosureApi) {
            return {
                restrict: "A",
                scope: {
                    disclosureId: "<figDisclosureSrc"
                },
                link: function (scope, elem) {
                    scope.$watch("disclosureId", updateSrc);
                    var lastObjUrl;

                    function updateSrc(disclosureId) {
                        if (!disclosureId) return;

                        scope.gettingDisclosure = true;

                        disclosureApi.getDisclosureFile(disclosureId).then(function (response) {
                            var url = URL.createObjectURL(response);
                            elem[0].src = url;
                            elem.addClass("");

                            if (lastObjUrl)
                                URL.revokeObjectURL(lastObjUrl);
                            lastObjUrl = url;
                        }, function () {});
                    }
                }
            };
        }
    ]);

})(window.app);